// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__RnkPW","txtSec":"styles_txtSec__RQfUq","ttl":"styles_ttl__jmEvs","txt":"styles_txt__5eCHf","img":"styles_img__PWLXX"};